var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTelephoneWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-telephone-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Final",
    transform: "translate(-323.000000, -952.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/Menu-mobile",
    transform: "translate(0.000000, 944.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/Menu",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(315.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-telephone-white",
    transform: "translate(7.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2857143,14.2857143 C17.2114286,14.2857143 15.2357143,13.8342857 13.4142857,12.9442857 C13.2428571,12.8585714 13.0457143,12.8485714 12.8671429,12.9114286 C12.6871429,12.9742857 12.54,13.1057143 12.4571429,13.2757143 L11.3342857,15.6 C8.42857143,13.9785714 6.02285714,11.5742857 4.40285714,8.66857143 L6.72571429,7.54285714 C6.89714286,7.46 7.02714286,7.31285714 7.09,7.13285714 C7.15142857,6.95428571 7.14,6.75714286 7.05571429,6.58571429 C6.16571429,4.76428571 5.71428571,2.78857143 5.71428571,0.714285714 C5.71428571,0.32 5.39428571,0 5,0 L0.714285714,0 C0.32,0 0,0.32 0,0.714285714 C0,11.3485714 8.65142857,20 19.2857143,20 C19.68,20 20,19.68 20,19.2857143 L20,15 C20,14.6057143 19.68,14.2857143 19.2857143,14.2857143 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 2.85714286,
    r: 1.42857143
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.2857143,
    cy: 2.85714286,
    r: 1.42857143
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.5714286,
    cy: 2.85714286,
    r: 1.42857143
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelephoneWhite);
export default __webpack_public_path__ + "static/media/ic-telephone-white.a76537b6a00aced8d4e137d105a9185d.svg";
export { ForwardRef as ReactComponent };